import blog1 from "../../images/blog_1.png";
import blog2 from "../../images/blog_2.png";
import blog3 from "../../images/blog_3.png";
import blog4 from "../../images/blog_4.png";
import blog5 from "../../images/blog_5.png";
import blog6 from "../../images/blog_6.png";
import blog7 from "../../images/blog_7.png";
import blog8 from "../../images/blog_8.png";
import blog9 from "../../images/blog_9.png";
import blogList1 from "../../images/blog_list_1.png"
import blogList2 from "../../images/blog_list_2.png"
import blogList3 from "../../images/blog_list_3.png"
import blogList4 from "../../images/blog_list_4.png"
import blogList5 from "../../images/blog_list_5.png"
import blogList6 from "../../images/blog_list_6.png"
import blogList7 from "../../images/blog_list_7.png"
import blogList8 from "../../images/blog_list_8.png"
import blogList9 from "../../images/blog_list_9.png"

export const BlogData = [
  {
    id: 1,
    img: blog1,
    img2 : blogList1,
    name: "Supplements & Herbs / When & Why to Take Them",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
  {
    id: 2,
    img: blog2,
    img2 : blogList2,
    name: "Staying in Your Exercise Routine on Vacation",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "17 Aug, 2022",
    classname : "news_blogs_box odd"
  },
  {
    id: 3,
    img: blog3,
    img2 : blogList3,
    name: "Start Your Yoga Journey & Set Your Soul on Fiii-yahhh",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
  {
    id: 4,
    img: blog4,
    img2 : blogList4,
    name: "Supplements & Herbs / When & Why to Take Them",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
  {
    id: 5,
    img: blog5,
    img2 : blogList5,
    name: "Staying in Your Exercise Routine on Vacation",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box odd"
  },
  {
    id: 6,
    img: blog6,
    img2 : blogList6,
    name: "Start Your Yoga Journey & Set Your Soul on Fiii-yahhh",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
  {
    id: 7,
    img: blog7,
    img2 : blogList7,
    name: "Staying in Your Exercise Routine on Vacation",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
  {
    id: 8,
    img: blog8,
    img2 : blogList8,
    name: "Start Your Yoga Journey & Set Your Soul on Fiii-yahhh",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box odd"
  },
  {
    id: 9,
    img: blog9,
    img2 : blogList9,
    name: "Supplements & Herbs / When & Why to Take Them",
    para: "Lorem ipsum dolor sit or it isamet, consectetur adipiscing elit, sed do  and this eiusmod tempor incididunt.",
    para2 : " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting,",
    btn : "READ Full Article",
    by : "By: Admin",
    date: "18 Aug, 2022",
    classname : "news_blogs_box"
  },
];
